export async function shipmentsShowUseCase(id, shipmentRepository) {
    
    const result = await shipmentRepository.show(id);
    
    const entity = new shipmentRepository.model_show(result.data.data.attributes);
    
    if (!entity.isValid()) {
        throw new Error("Shipment show inválido");
    }

    return entity;
}